import { APIClient } from "api/api_helper";
import { ACTUAl_COUNT_API, PHARMACY_LEDGER_API,DAILY_ACCOUNTABILITY_API } from "api/url_helper";

const api = new APIClient();

export const pharmacyLedgerService = {
  selectAll: (payload: any) => {
    return api.create(PHARMACY_LEDGER_API.PHARMACY_LEDGER_API + "SelectAll", {
      ...payload,
    });
  },
  selectAllDailyAccountability: (payload: any) => {
    return api.create(DAILY_ACCOUNTABILITY_API.DAILY_ACCOUNTABILITY_API + "SelectAll", {
      ...payload,
    });
  },

  actualCount: (payload: any) => {
    return api.create(ACTUAl_COUNT_API.ACTUAL_COUNT_API + "Insert", {
      ...payload,
    });
  },
  updateActualCount: (payload: any) => {
    return api.create(ACTUAl_COUNT_API.ACTUAL_COUNT_API + "Update", {
      ...payload,
    });
  },

  verifyPin: (payload: { verifypin: string; accountabilityid: number; studyid: number; verifiedby: number }) => {
    return api.create(ACTUAl_COUNT_API.ACTUAL_COUNT_API + "Verify", payload);
  },
};